// extracted by mini-css-extract-plugin
export default {"link":"ZK-z","disabled":"_K-z"};